import Promise from 'bluebird';
import { http } from '@bingads-webui/http-util';

import { DEFAULT_BING_MAP_API_KEY } from './utils';

const BING_MAPS_API_BASE_URL = 'https://dev.virtualearth.net/REST/v1/';

const LOCATIONS_PATH = 'Locations';
const AUTO_SUGGEST_PATH = 'Autosuggest';

export function LocationService({
  apiKey = DEFAULT_BING_MAP_API_KEY,
}) {
  const service = {};

  service.query = (query) => {
    if (query) {
      const url = `${BING_MAPS_API_BASE_URL}${LOCATIONS_PATH}`;

      return http.get(`${url}`, {
        data: {
          key: apiKey,
          o: 'json',
          incl: 'ciso2',
          query,
        },
        // to avoid a CORS check, content type needs to be empty string
        // see: https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
        contentType: '',
      });
    }
    return Promise.resolve({});
  };

  service.autoSuggest = (query, maxResults = 5) => {
    if (query) {
      const url = `${BING_MAPS_API_BASE_URL}${AUTO_SUGGEST_PATH}`;

      return http.get(`${url}`, {
        data: {
          key: apiKey,
          query,
          maxRes: maxResults,
        },
        // to avoid a CORS check, content type needs to be empty string
        // see: https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
        contentType: '',
      });
    }
    return Promise.resolve({});
  };

  return service;
}
